import { useCallback, useEffect, useState } from "react";

export function useBurgerMenu({
  initialOpen = false,
  closeOnEsc = true,
  onOpenChange,
} = {}) {
  const [open, setOpen] = useState(initialOpen);

  const openMenu = useCallback(() => {
    setOpen(true);
    onOpenChange?.(true);
  }, [onOpenChange]);

  const closeMenu = useCallback(() => {
    setOpen(false);
    onOpenChange?.(false);
  }, [onOpenChange]);

  const toggleMenu = useCallback(() => {
    setOpen((v) => {
      const next = !v;
      onOpenChange?.(next);
      return next;
    });
  }, [onOpenChange]);

  useEffect(() => {
    if (!closeOnEsc || !open) return;

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMenu();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [open, closeOnEsc, closeMenu]);

  return { open, openMenu, closeMenu, toggleMenu, setOpen };
}
